import { useTranslation } from "react-i18next";
import { FC, Props } from "./typings";
import styles from "./styles.module.scss";

import CloseIcon from "assets/icons/close.svg?react";
import casesService from "api/casesService";
import moment from "moment";

const CaseSharesModal: FC<Props> = ({ toggle, CaseId }) => {
  const { t } = useTranslation();
  const { data: CaseData } = casesService.useGetCase(CaseId ?? "");

  const getStatus = (status: number) => {
    switch (status) {
      case 0:
        return t("shareStatuses.invited");
      case 1:
        return t("shareStatuses.waitingForConfirmation");
      case 10:
        return t("shareStatuses.active");
      case 99:
        return t("shareStatuses.removed");
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <div className={styles.title}>
          {t("modals.shares")}
          <CloseIcon
            onClick={() => toggle(false)}
            className={styles.closeIcon}
          />
        </div>
        <div className={styles.list}>
          {CaseData?.Participants.filter((p) => (p.Privileges ?? 0) > 0).map(
            (r) => {
              return (
                <div key={r.Id} className={styles.case}>
                  <div className={styles.metaData}>
                    <div className={styles.s}>
                      <div className={styles.signature}>{r.Label}</div>
                      <div className={styles.status}>
                        {<>{getStatus(r.Status ?? 0)}</>}
                      </div>
                    </div>
                    <div className={styles.client}>
                      {moment(r.CreationDate).format("DD.MM.YYYY").toString()}
                    </div>
                  </div>

                  {/* <div className={styles.menu}>
                  <CaseIcon onClick={() => openCase(r.CaseId)} />
                </div> */}
                </div>
              );
            },
          )}
          {CaseData?.Shares.map((r) => {
            return (
              <div key={r.Id} className={styles.case}>
                <div className={styles.metaData}>
                  <div className={styles.s}>
                    <div className={styles.signature}>{r.To}</div>
                    <div className={styles.status}>{<>{getStatus(10)}</>}</div>
                  </div>
                  <div className={styles.client}>
                    {moment(r.Date).format("DD.MM.YYYY").toString()}
                  </div>
                </div>

                {/* <div className={styles.menu}>
                  <CaseIcon onClick={() => openCase(r.CaseId)} />
                </div> */}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CaseSharesModal;
